import { isErrorWithType, isRequestError } from '../requests';

/**
 * Преобразует ошибку в тип/код ошибки, пригодный для отправки в логах Метрики (trackGoal)
 * @param error любая ошибка
 * @returns тип/код ошибки
 * @kind helper
 */
export const prepareErrorForLog = (error: unknown) => {
    if (typeof error === 'string') {
        // тут может конечно просочиться не только тип/код, но и текст ошибки,
        // но вероятно для логов это будет все равно полезнее, чем 'unknown'
        return error;
    }

    if (error && typeof error === 'object' && 'isCanceled' in error && error.isCanceled) {
        return 'canceled';
    }

    if (isErrorWithType(error)) {
        return error.responseData.type;
    }

    if (isRequestError(error)) {
        return error.responseData.code;
    }

    return 'unknown';
};
